
<template>
    <div class="prompt-get-point-modal-wrap">
      <transition name="popup">
        <div class="modal" v-show="show">
          <Icon :img="require('../../assets/icon-close-modal.png')" class="close-btn" @click.native="handleCancel"/>
          <div class="modal-banner">
            <Icon :img="require('../../assets/icon-prompt.png')" class="banner"/>
          </div>
          <div class="modal-body">
            <div class="text0">积分不足</div>
            <div class="text1">是否前往“酷宝大转盘”赢取积分</div>
            <div class="text2"><ModalCheckboxButton @onChange="muteNotify"/> 不再显示游戏内容</div>
            
          </div>
          <div class="modal-actions">
            <a href="javascript:;" @click="handleCancel">取消</a>
            <a href="javascript:;" class="primary" @click="go">前往游戏</a>
          </div>
        </div>
      </transition>
      <div class="mask" v-if="show"></div>
    </div>
</template>

<script>
import ModalCheckboxButton from '@/components/kubaolottery/ModalCheckboxButton'

const MuteNotifySettingName = 'KubaoLotteryMute';

export default {
  props: ["url"],
  components:{ModalCheckboxButton},
  data(){
    return {
      isMuteNotify: false,
      show: false,
    }
  },
  methods: {
    muteNotify(isMuteNotify){
      this.isMuteNotify = isMuteNotify;
    },
    needNotify(){
      var valStr = localStorage.getItem(MuteNotifySettingName);
      if(valStr == '1'){
        return false;
      }
      return true;
    },
    go() {
      window.location.href=this.url
    },
    handleCancel(){
      if(this.isMuteNotify){
        localStorage.setItem(MuteNotifySettingName, '1');
      }
      this.show = false;
    },
    display(){
      this.show = true;
    }
  }
};
</script>

<style lang="less" scoped>

.modal{
  width: 80vw;
  border-radius: 2.13vw;
  background: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  z-index: 12;

  .close-btn{
    @size: 3.2vw;
    width: @size;
    height: @size;
    position: absolute;
    top: 4vw;
    right: 4vw;

  }

  .modal-banner{
    text-align: center;
    .banner{
      @size: 20vw;
      width:@size;
      height: @size;
      display: inline-block;
      margin-top: 6.67vw;
    }
  }

  .modal-body{
    text-align: center;
    color: #333;
    .text0{
      font-size: 4.8vw;
      line-height: 2em;
      
    }

    .text1{
      font-size: 4vw;
      line-height: 2em;
      
    }

    .text2{
      font-size: 4vw;
      line-height: 1em;
      color: #999;
      padding-top: 2.67vw;
      padding-bottom: 6.67vw;
    }
  }

  .modal-actions{
    text-align: center;
    border-top: 1px solid #E6E6E6;
    padding-top: 2.67vw;
    padding-bottom: 2.67vw;

    a{
      width: 39vw;
      display: inline-block;
      text-align: center;
      line-height: 8vw;
      font-size: 4.53vw;
      color: #333;

      &.primary{
        color: #E05650;
        border-left: 1px solid #E6E6E6;
      }
    }
  }
}

.mask{
  position: fixed;
  z-index: 11;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: .6;
}
</style>





// WEBPACK FOOTER //
// src/components/kubaolottery/PromptGetPointModal.vue